import React, { useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

import PropTypes from 'prop-types';

import Element from '@/components/common/Toast/Element';
import Icon from '@/components/common/Toast/Icon';
import classes from '@/components/common/Toast/style.module.scss';
import CloseImage from '@/images/icons/times.svg';

const timeouts = {};
const ToastComponent = ({ hideToast, toasts, handleToastClick }) => {
  const container = useRef();

  useEffect(() => {
    toasts.forEach(toast => {
      if (toast.duration) {
        if (!timeouts[toast.id]) {
          timeouts[toast.id] = setTimeout(() => {
            hideToast(toast.id);
          }, toast.duration);
        }
      }
    });
  }, [hideToast, toasts]);

  const handleCloseClick = (toastId, evt) => {
    evt.preventDefault();
    clearTimeout(timeouts[toastId]);
    hideToast(toastId);
  };

  return (
    <div className={classes.toastContainer} ref={container}>
      {toasts.map(toast => (
        <Element
          key={toast.id}
          data={toast}
          className={cn(
            classes.toast,
            'animate-in fade-in slide-in-from-right-5'
          )}
          handleClick={() => handleToastClick(toast.id, toast.onClick)}
        >
          <button type="button" className={classes.closeButton} onClick={evt => handleCloseClick(toast.id, evt)}>
            <img src={CloseImage} alt="Fechar" />
          </button>
          <div className={classes.icon}>
            <Icon type={toast.type} className="w-full h-full" />
          </div>
          <div className={classes.content}>
            <h5 className={classes.title}>{toast.title}</h5>
            <p className={classes.text}>{toast.text}</p>
          </div>
        </Element>
      ))}
    </div>
  );
};

ToastComponent.propTypes = {
  hideToast: PropTypes.func.isRequired,
  toasts: PropTypes.array,
  handleToastClick: PropTypes.func.isRequired,
};

ToastComponent.defaultProps = {
  toasts: [],
};

export default ToastComponent;
